import { NavLink } from "react-router-dom";
import logoSrc from "@/assets/logo.png";

const C = {
  navy: "#07081a",
  purple: "#6C63FF",
  white: "#ffffff",
  slate: "#c4c9e8",
  dimSlate: "#7880a8",
  border: "rgba(108,99,255,0.2)",
};

const productLinks: { label: string; to: string }[] = [
  { label: "Policy", to: "/features/policy" },
  { label: "Compliance", to: "/features/compliance" },
  { label: "Risk", to: "/features/risk" },
  { label: "Governance", to: "/features/governance" },
];

interface MarketingNavProps {
  activePage?: string;
}

export function MarketingNav({ activePage }: MarketingNavProps = {}) {
  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-8 py-4"
      style={{
        background: "rgba(7,8,26,0.85)",
        backdropFilter: "blur(20px)",
        borderBottom: "1px solid rgba(108,99,255,0.12)",
      }}
    >
      {/* Logo + wordmark */}
      <NavLink to="/welcome" className="flex items-center gap-2.5 min-w-[160px]">
        <img src={logoSrc} alt="ManagEaze" style={{ height: 28, width: "auto", flexShrink: 0 }} />
        <span
          style={{
            fontFamily: "'DM Sans', ui-sans-serif, sans-serif",
            fontWeight: 700,
            fontSize: "1rem",
            color: C.white,
            letterSpacing: "-0.02em",
          }}
        >
          ManagEaze
        </span>
      </NavLink>

      {/* Centred nav links */}
      <div className="hidden md:flex items-center gap-7 absolute left-1/2 -translate-x-1/2">
        {productLinks.map(({ label, to }) => (
          <NavLink
            key={label}
            to={to}
            className="text-sm font-medium transition-all hover:opacity-100"
            style={({ isActive }) => ({
              color: isActive || activePage === label.toLowerCase() ? C.white : C.dimSlate,
            })}
          >
            {label}
          </NavLink>
        ))}
        <NavLink
          to="/consulting"
          className="text-sm font-medium transition-all hover:opacity-100"
          style={({ isActive }) => ({ color: isActive ? C.white : C.dimSlate })}
        >
          Consulting
        </NavLink>
      </div>

      {/* Right CTAs */}
      <div className="flex items-center gap-3 min-w-[160px] justify-end">
        <NavLink
          to="/auth"
          className="text-sm font-medium px-4 py-2 rounded-lg transition-all hover:opacity-80"
          style={{ color: C.slate, border: `1px solid ${C.border}` }}
        >
          Sign in
        </NavLink>
        <NavLink
          to="/auth"
          className="cta-glow text-sm font-semibold px-4 py-2 rounded-lg transition-all hover:opacity-90"
          style={{ background: C.purple, color: C.white }}
        >
          Get Started
        </NavLink>
      </div>
    </nav>
  );
}
